import React, { useEffect } from "react";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";

import SearchBootstrapTable from "app/Components/BootstrapTable/SearchBootstrapTable";
import { useState } from "react";
import { CommmonService } from "app/_services/CommonService/CommonService";
const Information = () => {
  const [informationList, setInformationList] = useState([]);
  const getInformationList = async () => {
    const response = await CommmonService.getInformationTableData();
    console.log("this is response Inside Infor", response);
    if (!response?.status) return;

    let data = response?.data || [];
    setInformationList(
      data.map((d, i) => ({
        ...d,
        sid: i + 1,
      }))
    );
  };
  const sortableColumn = [
    {
      dataField: "sid",
      text: "S.No.",
      sort: true,
    },
    {
      dataField: "informationKey",
      text: "Information ",
      sort: true,
    },
    {
      dataField: "informationValue",
      text: "Information Date",
      sort: true,
    },
  ];

  useEffect(() => {
    getInformationList();
  }, []);
  return (
    <div>
      <MainBreadcrumb
        routeSegments={[
          { name: "Admin Panel", path: "#" },
          { name: "Information", path: "#" },
        ]}
        breadCrumbsText="User_Management_User_Registration"
      />

      <div className="healthSafetyEnvironmentWrapper">
        <div className="p-2">
          <div className="card p-3 mt-3">
            <div className="simple-card-title">
              <h3 className="text-capitalize mb-1">Information</h3>
            </div>
            <>
              <SearchBootstrapTable
                searchKey={"capaOwnerDesktopSearch"}
                data={informationList}
                columns={sortableColumn}
                tableDownloadFlag={false}
              />
            </>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Information;
